import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../layout/Layout";
import "./visualPresentation.css";
import Image1 from "../assets/img/image_1.png";
import Image4 from "../assets/img/image_4.png";
import Image5 from "../assets/img/image_5.png";
import Image6 from "../assets/img/image_6.png";
import Image7 from "../assets/img/image_7.png";
import Line from "../assets/img/Line.png";

const VisualPresentation = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [autoSlideChange, setAutoSlideChange] = useState(true);

  const changeSlide = (index) => {
    setActiveSlide(index);
    setAutoSlideChange(false);
  };

  const nextSlide = () => {
    setActiveSlide((prevSlide) => (prevSlide + 1) % 5);
  };

  useEffect(() => {
    let interval;

    if (autoSlideChange) {
      interval = setInterval(nextSlide, 3000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [autoSlideChange]);

  return (
    <Layout>
      <div className="container">
        {/* <div className="md:flex justify-between  my-3">
          <div className="flex font-semibold gap-3 justify-center items-center ml-10 mt-2">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C] text-[20px]">Visual Presentation</h1>
          </div>
        </div> */}
        <div className="md:flex justify-between  my-4">
          <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C]">Visual Presentation</h1>
          </div>
        </div>
        <div className="shadow-xl   p-2 rounded-xl bg-white mt-7">
          {" "}
          <div className="text-3xl text-[#22345C] font-semibold my-2 mx-2">
            R2V3 Standard Certification : A Step By Step Guide For The
            Implementation{" "}
          </div>
          <div>
            <section id="slider">
              {[1, 2, 3, 4, 5].map((index) => (
                <input
                  type="radio"
                  name="slider"
                  id={`s${index}`}
                  key={index}
                  checked={activeSlide === index - 1}
                  onClick={() => changeSlide(index - 1)}
                  className="accent-[#22345C]"
                />
              ))}

              <label htmlFor="s1" id="slide1" className="slide-label">
                <img
                  src={Image7}
                  alt=""
                  className="w-[100%] h-[100%] rounded-lg"
                />
                <Link to="/slider">
                  <div className="absolute left-2 bottom-2 px-3 py-2 border-[1.5px] bg-white text-[#22345C] rounded-lg text-[20px]">
                    Phase 1
                  </div>
                </Link>
              </label>
              <label htmlFor="s2" id="slide2" className="slide-label">
                <img
                  src={Image4}
                  alt=""
                  className="w-[100%] h-[100%] rounded-lg"
                />
                <Link to="/slider">
                  <div className="absolute left-2 bottom-2 px-3 py-2 border-[1.5px] bg-white text-[#22345C] rounded-lg text-[20px]">
                    Phase 2
                  </div>
                </Link>
              </label>
              <label htmlFor="s3" id="slide3" className="slide-label">
                <img
                  src={Image1}
                  alt=""
                  className="w-[100%] h-[100%] rounded-lg"
                />
                <Link to="/slider">
                  <div className="absolute left-2 bottom-2 px-3 py-2 border-[1.5px] bg-white text-[#22345C] rounded-lg text-[20px]">
                    Phase 3
                  </div>
                </Link>
              </label>
              <label htmlFor="s4" id="slide4" className="slide-label">
                <img
                  src={Image6}
                  alt=""
                  className="w-[100%] h-[100%] rounded-lg"
                />
                <Link to="/slider">
                  <div className="absolute left-2 bottom-2 px-3 py-2 border-[1.5px] bg-white text-[#22345C] rounded-lg text-[20px]">
                    Phase 4
                  </div>
                </Link>
              </label>
              <label htmlFor="s5" id="slide5" className="slide-label">
                <img
                  src={Image5}
                  alt=""
                  className="w-[100%] h-[100%] rounded-lg"
                />
                <Link to="/slider">
                  <div className="absolute left-2 bottom-2 px-3 py-2 border-[1.5px] bg-white text-[#22345C] rounded-lg text-[20px]">
                    Phase 5
                  </div>
                </Link>
              </label>
            </section>
          </div>
        </div>
        <div className="flex justify-center items-center mt-7">
          <Link to="/slider">
            <button class="bg-[#22345C]  text-white font-medium py-2 px-8 rounded">
              SHOW ME HOW
            </button>
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default VisualPresentation;
